var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: {
        appBarTitle: _vm.$tr("permissionsTitle"),
        route: _vm.backRoute,
        loading: _vm.isPageLoading,
      },
    },
    [
      !_vm.isPageLoading
        ? _c(
            "KPageContainer",
            { staticClass: "device-container" },
            [
              _vm.user === null
                ? _c("h1", [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$tr("userDoesNotExist")) +
                        "\n    "
                    ),
                  ])
                : [
                    _c("div", { staticClass: "section user-info" }, [
                      _c(
                        "h1",
                        { attrs: { dir: "auto" } },
                        [
                          _c("KLabeledIcon", {
                            attrs: {
                              icon: "person",
                              label: _vm.isCurrentUser
                                ? _vm.$tr("you")
                                : _vm.user.full_name,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("table", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.coreString("usernameLabel")) +
                                "\n            "
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(_vm.user.username))]),
                        ]),
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.coreString("userTypeLabel")) +
                                "\n            "
                            ),
                          ]),
                          _c(
                            "td",
                            [
                              _c("UserTypeDisplay", {
                                attrs: { userType: _vm.UserType(_vm.user) },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.coreString("facilityLabel")) +
                                "\n            "
                            ),
                          ]),
                          _c("td", { attrs: { dir: "auto" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.facilityName) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "section superuser" },
                      [
                        _c(
                          "KCheckbox",
                          {
                            staticClass: "super-admin-checkbox",
                            attrs: {
                              disabled: _vm.superuserDisabled,
                              checked: _vm.superuserChecked,
                            },
                            on: {
                              change: function ($event) {
                                _vm.superuserChecked = $event
                              },
                            },
                          },
                          [
                            _c("span", { style: _vm.superuserLabelStyle }, [
                              _vm._v(_vm._s(_vm.$tr("makeSuperAdmin"))),
                            ]),
                            _c("PermissionsIcon", {
                              staticClass: "permissions-icon",
                              attrs: {
                                permissionType: "SUPERUSER",
                                lightIcon: _vm.superuserDisabled,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "ul",
                          {
                            staticClass: "checkbox-description",
                            style: {
                              color: _vm.superuserDisabled
                                ? _vm.$themeTokens.textDisabled
                                : _vm.$themeTokens.annotation,
                            },
                          },
                          [
                            _c("li", [
                              _vm._v(_vm._s(_vm.$tr("superAdminExplanation1"))),
                            ]),
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm.$tr("superAdminExplanation2", {
                                    facilityName: _vm.facilityName,
                                  })
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "section" },
                      [
                        _c("h2", [
                          _vm._v(
                            _vm._s(_vm.coreString("devicePermissionsLabel"))
                          ),
                        ]),
                        _c("KCheckbox", {
                          attrs: {
                            disabled: _vm.devicePermissionsDisabled,
                            label: _vm.$tr("devicePermissionsDetails"),
                            checked: _vm.devicePermissionsChecked,
                          },
                          on: {
                            change: function ($event) {
                              _vm.devicePermissionsChecked = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        _c(
                          "KButtonGroup",
                          [
                            _c("KButton", {
                              attrs: {
                                disabled: _vm.saveDisabled,
                                text: _vm.$tr("saveButton"),
                                primary: true,
                                appearance: "raised-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            }),
                            _c("KButton", {
                              attrs: {
                                disabled: _vm.uiBlocked,
                                text: _vm.coreString("cancelAction"),
                                primary: false,
                                appearance: "flat-button",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.goBack()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.saveFailed
                      ? _c("div", [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$tr("saveFailureNotification")) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }